module.exports = __webpack_public_path__ + "img/logo.3fadff17.png";